import { Context, createContext, useContext, useEffect, useReducer, useRef } from "react";
import deepEqual from "fast-deep-equal/es6";
import ApiCaller from "../utils/ApiTemplate";
import { FunctionObjectType } from "../utils/Types";
import { AuthStateActionType, AuthStateType } from "./auth";
import { MenuStateActionType, MenuStateType } from "./menu";

function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value
    });
    return ref.current;
};

export type StateContextPropertyType = {
    apiCaller?: ApiCaller,
    authState?: AuthStateType,
    setAuthState: FunctionObjectType<AuthStateActionType>,
    menuState?: MenuStateType,
    setMenuState: FunctionObjectType<MenuStateActionType>,
};

export function usePersistedReducer(
    reducer: any,
    initialState: any,
    storageKey: any,
) : {state: any, dispatch: FunctionObjectType<any>}
{
    const [state, dispatch] = useReducer(reducer, initialState, init);
    const prevState = usePrevious(state);

    function init() {
        const stringState = localStorage.getItem(storageKey);
        if (stringState) {
            try {
                return JSON.parse(stringState);
            } catch (error) {
                return initialState;
            }
        } else {
            return initialState
        }
    }

    useEffect(() => {
        const stateEqual = deepEqual(prevState, state);
        if (!stateEqual) {
            const stringifiedState = JSON.stringify(state)
            localStorage.setItem(storageKey, stringifiedState)
        }
    }, [state]);

    return { state, dispatch };
}

const StateContext: Context<StateContextPropertyType> = createContext({
    setAuthState: () => {},
    setMenuState: () => {},
});
export default StateContext;

export function useStateContext(): StateContextPropertyType {
    return useContext(StateContext);
};